import { ImgHTMLAttributes } from 'react';
import { useCurrentWidth } from '@fff-web/fff-ui-shared';
import { getImagesStaticUrl } from '../../../../helpers';
import breakpoints from '../../../../utils/breakpoints';

export const BoxImage = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  // State
  const currentWidth = useCurrentWidth();

  // Constants
  const displayMobileLarge = currentWidth > 377 && currentWidth <= 511;
  const boxImageName =
    currentWidth > breakpoints.medium
      ? 'lock-in-rate-desktop.jpg'
      : displayMobileLarge
        ? 'lock-in-rate-mobile-large.jpg'
        : 'lock-in-rate-mobile-short.jpg';

  return <img alt={props.alt || ''} {...props} src={getImagesStaticUrl(boxImageName)} />;
};
